export default "__VITE_ASSET__aFyrDURb__"